import { useModalStore } from "store/modal/hooks/useModalStore";

import { Button } from "@krea/shared/design-system/Button";
import { AppModal } from "@krea/shared/design-system/modal";

import { useReopenLenderApplicationMutation } from "@/features/lender-applications/hooks/data/use-reopen-lender-application.mutation";

const ReopenApplicationModal = () => {
  const modalParams = useModalStore((state) =>
    state.modalParams?.type === "reopen" ? state.modalParams.params : null,
  );

  const { mutate: reopenApplication } = useReopenLenderApplicationMutation();

  const {
    loading: isModalLoading,
    closeModal,
    setModalLoading,
  } = useModalStore((state) => ({
    loading: state.loading,
    closeModal: state.closeModal,
    setModalLoading: state.setModalLoading,
  }));

  const onCloseModal = () => {
    closeModal();
  };

  const onSubmit = () => {
    if (!modalParams) return;
    setModalLoading(true);
    reopenApplication(
      {
        lenderCompanyId: modalParams.lenderCompanyId,
        lenderApplicationId: modalParams.lenderApplicationId,
      },
      {
        onSuccess: () => {
          setModalLoading(false);
          closeModal();
        },
      },
    );
  };

  if (!modalParams) return null;

  return (
    <AppModal
      open={true}
      setOpen={(open) => {
        if (!open) onCloseModal();
      }}
      onClose={onCloseModal}
      title={`Reopen application #${modalParams.lenderApplicationId}`}
      footer={
        <>
          <Button variant="secondary" onClick={onCloseModal}>
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={onSubmit}
            disabled={isModalLoading}
          >
            Reopen
          </Button>
        </>
      }
    >
      <h6 className="mb-5">
        Are you sure you want to reopen application #
        {modalParams.lenderApplicationId}?
      </h6>
    </AppModal>
  );
};

export default ReopenApplicationModal;
